const INFO = {
	main: {
		title: "Vrushab's portfolio",
		name: "Vrushab Hanumesh",
		email: "vrushab1998@gmail.com",
		logo: "../logo.jpg",
	},

	socials: {
		twitter : "https://www.youtube.com/@vrushab_07",
		github: "https://github.com/VrushabHayagreev/",
		linkedin: "https://www.linkedin.com/in/vrushab-hayagreev/",
		instagram: "https://www.instagram.com/vrushabhanumesh/",

	},

	homepage: {
		title: "Full-time web developer and a part-time Gamer",
		description:
			"I am a Full stack Web Developer with a years experience working on React, NodeJS, Mysql PERL and Splunk. I have a masters degree in computer science and i like to build scalable and reliable web applications.",
	},

	about: {
		title: "Hi, I am Vrushab Hanumesh a full-time developer and a part-time gamer",
		description:
			"My home page gives a pretty clear idea of my experience and projects but here I want to tell about my other side. I am a part-time gamer with a small youtube channel where i stream pubg and valorant i am pretty good at PUBG i think. I like reading books, i have abookstragram accountwhere i post reviews i am planning to build an application for that as well pretty soon",
	},

	articles: {
		title: "My Paper Publications.",
		description:
			"I have worked on more than 10 projects since my undergrads and here are the few paper publications of those projects",
	},

	projects: [
		{
			title: "FLASHSHIP",
			description:
				"Successfully deployed a Delivery Management System, enabling customers to conveniently ship goods from any location to another. Optimized the backend performance by leveraging NodeJS and implementing API calls to fetch user data.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/Flashship",
			
		},

		{
			title: "DEEP DREAMING AND ARTISTIC STYLE TRANSFER",
			description:
				"Built a Convolutional Neural network using Artistic Style Transfer which makes use of an inception network in deep learning to build a hallucinating appearance of a given base image",
			logo: "https://img.freepik.com/premium-vector/brain-logo-template_15146-27.jpg",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/DeepDreaming",
		},

		{
			title: "PG FINDER USING GOOGLE MAPS API",
			description:
				"Implemented a full-stack web application that enables students to search for Paying Guest accommodations near their college based on various criteria such as price, availability, and distance",
			logo: "https://images.g2crowd.com/uploads/product/image/large_detail/large_detail_8d58e1295b8ad54a323f7f5ac55e5280/google-maps-api.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/PG-Finder",
			
		},

		{
			title: "Bitcoin Prediction Using RNN",
			description:
				"Used RNN to predict the bitcoin price with 85% accuracy using the yahoo raw data",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/800px-Bitcoin.svg.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/Bitcoin-Prediction-Using-RNN",
			
		},

		{
			title: "RTO Management System",
			description:
				"Developed a full stack web application to help the user to get the license, allow the official to issue driving license, fine, delete the user and update the user data",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/2560px-Node.js_logo.svg.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/RTO-Management-System",
			
		},
		{
			title: "Portfolio",
			description:
				"Developed a full stack web application for creating my own portfolio including my experiences and other extra caricular acivities. I will keep updating this",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/Portfolio",
			
		},
		{
			title: "Wireless Digital notice Board Using Raspberry Pie",
			description:
				"Built a Web application for the computer science department of my college for handling he academic activities for both faculties and students like assignments, grading etc. Used Raspberry Pie to display it on a wireless notice board",
			logo: "https://www.shutterstock.com/image-vector/internet-things-glyph-icon-silhouette-260nw-1172566369.jpg",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/Wireless-Digital-Board",
			
		},
		{
			title: "BookishWiz",
			description:
				"Developer a NextJS Blog application to display all my book reviews which i have written over the years. Used GraphQL for creating the queries and stroring data.",
			logo: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/BookishWiz",
			
		},
		{
			title: "Rahuls Portfolio",
			description:
				"Developer a Basic HTML portfolio for my roomnate where i developed the frontend and he did the requirement gathering",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/640px-HTML5_logo_and_wordmark.svg.png",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/RahulsPortfolio",
			
		},
		{
			title: "S8ul",
			description:
				"Developer Next JS application for the s8ul organization a one stop for every details about s8ul from content creation, esport, tournaments, achievements to owners.",
			logo: "https://www.svgrepo.com/show/354113/nextjs-icon.svg",
			linkText: "View Project",
			link: "https://github.com/VrushabHayagreev/s8ul",
			
		},
	],
};

export default INFO;
